import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgmCoreModule } from '@agm/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { ErrorComponent } from './pages/errors/error/error.component';
import { TopInfoContentComponent } from './theme/components/top-info-content/top-info-content.component';
import { SidenavComponent } from './theme/components/sidenav/sidenav.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { MessagesComponent } from './theme/components/messages/messages.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { FavoritesComponent } from './theme/components/favorites/favorites.component';
import { UnauthorizedComponent } from './pages/errors/unauthorized/unauthorized.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalErrorHandler } from './shared/utils/global-errorhandler';
import { NetworkInterceptor } from './shared/utils/network-interceptor';
import { EmailAlreadyRegisteredComponent } from './pages/errors/email-already-registered/email-already-registered.component';
import { UrlSerializer } from '@angular/router';
import { LowerCaseUrlSerializer } from './shared/classes/lower-case-url-serializer';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	wheelPropagation: true,
	suppressScrollX: true
};

@NgModule({
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyBNcjxo_35qnEG17dQvvftWa68eZWepYE0'
		}),
		PerfectScrollbarModule,
		CalendarModule.forRoot({
			provide: DateAdapter,
			useFactory: adapterFactory
		}),
		SharedModule,
		HttpClientModule,
		AppRoutingModule
	],
	declarations: [
		AppComponent,
		PagesComponent,
		NotFoundComponent,
		ErrorComponent,
		TopInfoContentComponent,
		SidenavComponent,
		VerticalMenuComponent,
		HorizontalMenuComponent,
		MessagesComponent,
		UserMenuComponent,
		FavoritesComponent,
		UnauthorizedComponent,
		EmailAlreadyRegisteredComponent
	],
	entryComponents: [
		VerticalMenuComponent
	],
	providers: [
		{ provide: ErrorHandler, useClass: GlobalErrorHandler },
		{ provide: HTTP_INTERCEPTORS, useClass: NetworkInterceptor, multi: true },
		// Not sure if this is still the right place
		{ provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
		// { provide: UrlSerializer, useClass: LowerCaseUrlSerializer }
	],
	bootstrap: [
		AppComponent
	]
})
export class AppModule { }
